var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "employee__app employee" }, [
    _c("div", { staticClass: "employee__links" }, [
      _c(
        "div",
        {
          staticClass: "employee__link",
          on: {
            click: function ($event) {
              return _vm.openSection("boardOfDirectors")
            },
          },
        },
        [
          _c("div", {
            staticClass: "employee__link-title",
            domProps: {
              textContent: _vm._s(_vm.$t("employee.boardOfDirectors.btn")),
            },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "employee__link-arrow",
            domProps: { innerHTML: _vm._s(require("../img/projectArrow.svg")) },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "employee__link",
          on: {
            click: function ($event) {
              return _vm.openSection("topManagement")
            },
          },
        },
        [
          _c("div", {
            staticClass: "employee__link-title",
            domProps: {
              textContent: _vm._s(_vm.$t("employee.topManagement.btn")),
            },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "employee__link-arrow",
            domProps: { innerHTML: _vm._s(require("../img/projectArrow.svg")) },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.boardOfDirectors.isOpened,
            expression: "boardOfDirectors.isOpened",
          },
        ],
        attrs: { id: _vm.boardOfDirectors.sectionId },
      },
      [
        _c(
          "collapse-transition",
          { attrs: { duration: 800, easing: "ease-in-out" } },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.boardOfDirectors.isOpened,
                    expression: "boardOfDirectors.isOpened",
                  },
                ],
              },
              [
                _c("h2", {
                  staticClass: "employee__title",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("employee.boardOfDirectors.title")
                    ),
                  },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "employee__undertitle",
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("employee.boardOfDirectors.underTitle")
                    ),
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "employee__board" },
                  [
                    _c("MobileSlider", {
                      attrs: { slides: this.boardOfDirectors.items },
                      scopedSlots: _vm._u([
                        {
                          key: "slide",
                          fn: function (ref) {
                            var slide = ref.slide
                            return [
                              _c(
                                "div",
                                { staticClass: "employee__board-item" },
                                [
                                  _c("div", {
                                    staticClass:
                                      "employee__board-item-position",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "employee.boardOfDirectors.items[" +
                                            slide.id +
                                            "].position"
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "employee__board-item-name",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "employee.boardOfDirectors.items[" +
                                            slide.id +
                                            "].name"
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "employee__board-item-desc",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t(
                                          "employee.boardOfDirectors.items[" +
                                            slide.id +
                                            "].desc"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "employee__link",
                    on: {
                      click: function ($event) {
                        return _vm.openSection("topManagement")
                      },
                    },
                  },
                  [
                    _c("div", {
                      staticClass: "employee__link-title",
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t("employee.topManagement.btn")
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "employee__link-arrow",
                      domProps: {
                        innerHTML: _vm._s(require("../img/projectArrow.svg")),
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.topManagement.isOpened,
            expression: "topManagement.isOpened",
          },
        ],
        staticClass: "container-sticky",
        attrs: { id: _vm.topManagement.sectionId },
      },
      [
        _c(
          "div",
          { staticClass: "content-sticky screen-section" },
          [
            _c(
              "collapse-transition",
              { attrs: { duration: 800, easing: "ease-in-out" } },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.topManagement.isOpened,
                        expression: "topManagement.isOpened",
                      },
                    ],
                  },
                  [
                    _c("h2", {
                      staticClass: "employee__title",
                      domProps: {
                        textContent: _vm._s(
                          _vm.$t("employee.topManagement.title")
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "employee__top" },
                      [
                        _c("MobileSlider", {
                          attrs: { slides: this.topManagement.items },
                          scopedSlots: _vm._u([
                            {
                              key: "slide",
                              fn: function (ref) {
                                var slide = ref.slide
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "employee__top-item",
                                      on: {
                                        mouseover: function ($event) {
                                          return _vm.onDirectorEnter(slide)
                                        },
                                        mouseleave: function ($event) {
                                          return _vm.onDirectorLeave(slide)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          ref: "itemContainer" + slide.id,
                                          staticClass:
                                            "employee__top-item-content",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "employee__top-item-img",
                                            },
                                            [
                                              _c("img", {
                                                attrs: {
                                                  src: _vm.assetUrl(
                                                    "../img/top/" + slide.img
                                                  ),
                                                  alt: "",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              ref: "itemPerson" + slide.id,
                                              staticClass:
                                                "employee__top-item-person",
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "employee__top-item-name",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "employee.topManagement.items[" +
                                                        slide.id +
                                                        "].name"
                                                    )
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "employee__top-item-position",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "employee.topManagement.items[" +
                                                        slide.id +
                                                        "].position"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.$mq === "mobile"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "employee__top-item-desc-wrapper",
                                                  style: _vm.descHeight(
                                                    slide.id
                                                  ),
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "employee__top-item-desc",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "employee.topManagement.items[" +
                                                            slide.id +
                                                            "].desc"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  ref: "itemDesc" + slide.id,
                                                  staticClass:
                                                    "employee__top-item-desc-wrapper",
                                                  style: _vm.descHeight(
                                                    slide.id
                                                  ),
                                                },
                                                [
                                                  slide.isHovered
                                                    ? _c(
                                                        "vuescroll",
                                                        {
                                                          attrs: {
                                                            ops: {
                                                              bar: {
                                                                background:
                                                                  "rgba(31,31,31,.4)",
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("div", {
                                                            staticClass:
                                                              "employee__top-item-desc",
                                                            domProps: {
                                                              textContent:
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "employee.topManagement.items[" +
                                                                      slide.id +
                                                                      "].desc"
                                                                  )
                                                                ),
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }